export const downloadFile = async (path: string) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.onload = () => {
      resolve(xhr.response);
    };
    xhr.onerror = (error) => {
      reject(error);
    };
    xhr.open('GET', path);
    xhr.send();
  });
};
